import React from 'react';
import './Hero.css'; // stil dosyasını da ekleyeceğiz

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>DİJİKOPİ</h1>
        <p>Büro Makineleri ve Servis Hiz. San. Tic. - Canon Yazıcı Fotokopi Bakım Tamir Satış Servisi . Profesyonel baskı ve kopyalama çözümleriniz burada.</p>
        <a href="#contact" className="hero-button">İletişime Geç</a>
      </div>
    </section>
  );
};

export default Hero;
